<template>
  <div class="container-fluid px-4 view-container">
    <hr />
    <div class="row justify-content-center">
        
        <h1>Zlecenia zrealizowane</h1>
        </div>
    <div class="row">
      <div class="col-sm-12 col-md-3">
       
          
        <h3>Wyszukaj zlecenie</h3>
        <hr />
        <input
          v-model="search"
          class="form-control mr-sm-2"
          type="search"
          placeholder="Wyszukaj zlecenie"
          aria-label="Search"
        />
        <hr />
      </div>

      <div class="col-12 col-md-9">
    <div class="row" v-if="tasks.length">
          <div
            class="card mt-1 ml-3 mr-0"
            style="width:90%;"
            v-for="task in filteredTasks"
            :key="task.id"
          >
            <div class="card-body">
              <div class="row">
                <div v-if="task.imageUrl" class="col-6">
                  <img
                    class="rounded mr-1"
                    style="height:120px; width:120px;"
                    v-bind:src="task.imageUrl"
                    alt
                  />
                </div>
                <div v-else class="col-6">
                    <svg width="130px" height="130px" viewBox="-5 -5 25 25" class="bi bi-camera" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M15 12V6a1 1 0 0 0-1-1h-1.172a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 9.173 3H6.828a1 1 0 0 0-.707.293l-.828.828A3 3 0 0 1 3.172 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
  <path fill-rule="evenodd" d="M8 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
  <path d="M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
</svg>
                </div>
                <div class="col-6 text-right">
                  
                    <span class="badge badge-warning ">{{ task.title }}</span>
                  
                  <br>
                  <span
                    class="time-format"
                    v-if="timeFormat"
                    @click="timeFormat= !timeFormat"
                  >{{task.createdOn | formatDate}}</span>
                  

                  <span
                    class="time-format"
                    v-else
                    @click="timeFormat = !timeFormat"
                  >{{task.createdOn | formatDate2}}</span>
                  <br />
                  <span
                    v-if="task.status=='dodany'"
                    class="text-right badge badge-info"
                  >{{task.status}}</span>
                  <span v-else class="text-right badge badge-success">{{task.status}}</span>
                  <br>
                  <hr>
                  <span class="float-left text-left ml-1 mt-1" style="font-size:12px;" >{{task.bike}}</span>
                </div> 
              </div>

      
              <hr>
              
              <div class="row justify-content-center">
                  <span>Zamknięte {{task.endDate | formatDate2}}</span>
              </div>

              <hr />
              <div class="row d-flex justify-content-center">
        
                <div class="col-12">
                  <button class="btn btn-primary" style="width:100%;" @click="openTask(task)">
                    <svg
                      width="1.5em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-arrows-fullscreen"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.464 10.536a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3.5a.5.5 0 0 1-.5-.5v-3.5a.5.5 0 0 1 .5-.5z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M5.964 10a.5.5 0 0 1 0 .707l-4.146 4.147a.5.5 0 0 1-.707-.708L5.257 10a.5.5 0 0 1 .707 0zm8.854-8.854a.5.5 0 0 1 0 .708L10.672 6a.5.5 0 0 1-.708-.707l4.147-4.147a.5.5 0 0 1 .707 0z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10.5 1.5A.5.5 0 0 1 11 1h3.5a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0V2h-3a.5.5 0 0 1-.5-.5zm4 9a.5.5 0 0 0-.5.5v3h-3a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M10 9.964a.5.5 0 0 0 0 .708l4.146 4.146a.5.5 0 0 0 .708-.707l-4.147-4.147a.5.5 0 0 0-.707 0zM1.182 1.146a.5.5 0 0 0 0 .708L5.328 6a.5.5 0 0 0 .708-.707L1.889 1.146a.5.5 0 0 0-.707 0z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M5.5 1.5A.5.5 0 0 0 5 1H1.5a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 1 0V2h3a.5.5 0 0 0 .5-.5z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      
      </div>
    </div>

    <task-modal :oneTask="oneTask" :key="taskKey" @clear-comments="taskReload()"></task-modal>
    <comment-modal :oneTask="oneTask" :key="commentKey" @clear-comment="commentReload()"></comment-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { fb, db } from "../firebase";
import moment from "moment";
import CommentModal from "@/components/CommentModal";
import { commentsCollection } from "@/firebase";
import TaskModal from "@/components/TaskModal";

export default {
  data() {
    return {
      task: {
        title: "",
        bike: "",
        frame: "",
        phone: "",
        address: "",
        content: "",
        imageUrl: "",
      },
      search: "",
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      taskComments: [],
      oneTask: "",
      timeFormat: false,
      taskKey: 0,
      commentKey: 100,
      printKey: 1000,
      disabled: 0,
      showSuccess: false,
    };
  },

  components: {
    "task-modal": TaskModal,
    "comment-modal": CommentModal,
  },

  computed: {
    ...mapState(["userProfile", "tasks"]),
    filteredTasks() {
      return this.tasks.filter((item) => {
          if(item.status == "zrealizowany") {
        return item.title.toUpperCase().includes(this.search.toUpperCase());
          }
      });
    },
  },
  methods: {
    taskReload() {
      this.taskKey += 1;
    },
    commentReload() {
      this.commentKey += 1;
    },
    openTask(oneTaskId) {
      this.$modal.show("task-modal");
      this.oneTask = oneTaskId;
    },
    addComment(task) {
      this.$modal.show("comment-modal");
      this.oneTask = task;
    },
    clearComments() {
      this.taskComments = [];
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      moment.locale("pl");
      return moment(date).fromNow();
    },
    formatDate2(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      moment.locale("pl");
      return moment(date).format('LL');
    },
  },
};
</script>
<style scoped>
.view-container {
  background-color: #f5f7f9;
}
.card {
  margin: 8px;
  max-width: 320px;
}

.time-format {
  color: gray;
  font-size: 12px;
  cursor: pointer;
}
.badge-warning {
  font-weight: 500;
}
.custom-file-input {
  display: none;
}
</style>